import { Link } from "react-router-dom";
import React from "react";

import H2 from "../../../components/typography/h2";
import OurClients from "../../../components/clients";

import Styles from "./styles.module.scss";
import styles from "./styles.module.scss";

// Image assets actually used
import wifi from "../../../assets/img/wifiicon.png";
import case_studies from "../../../assets/img/case_studiesicon.png";

// Case study image actually used
import AssetGlance from "../../../digitalmarketing/assetglance.png";
import FatatShawarma from "../../../digitalmarketing/FatatShawarma.png";
import Beirut from "../../../digitalmarketing/Beirut.png";
import GrandBeirut from "../../../digitalmarketing/grandbeirut.png";
import Hostec from "../../../digitalmarketing/Hostec.png";
import Karavali from "../../../digitalmarketing/karavali.png";
import Raclette from "../../../digitalmarketing/raclette.png";
import ScentaBook from "../../../digitalmarketing/scentabook.png";
import SpaceY from "../../../digitalmarketing/SpaceY.png";
import Spera from "../../../digitalmarketing/Spera.png";
import UniWell from "../../../digitalmarketing/Uniwell.png";
import Zeeqr from"../../../digitalmarketing/zeeqr.png";
import AmberAroma from"../../../digitalmarketing/AmberAroma.png";
import WOW from "../../../digitalmarketing/Wow.png";
import SipScoop from "../../../digitalmarketing/SipScoop.png";
import View from "../../../digitalmarketing/360view.png";


function DigitalMarketing() {
  const scrollToTop = () => {
    window.scrollTo({
      top: 0,
      behavior: "smooth",
    });
  };

  interface ShowcaseItem {
    image: string;
    category: string;
    title: string;
    link?: string;
    website?: string;
  }

  // Keeping only one project
  const showcaseItems: ShowcaseItem[] = [
    {
      image: Beirut,
      category: "Photography, Videography & Social media management",
      title: "Beirut Sur Mer",
      link: "https://metasoftdm.com/success-stories/beirut-sur-mer/",
      website: "https://metasoftdm.com/success-stories/beirut-sur-mer/",
    },
    {
      image: GrandBeirut,
      category: "Photography, Videography & Social media management",
      title: "Grand Beirut",
      link: "https://metasoftdm.com/success-stories/grandbeirut/",
      website: "https://metasoftdm.com/success-stories/grandbeirut/",
    },
    {
      image: Raclette,
      category: "Photography, Videography & Social media management",
      title: "Raclette Brasserie & cafe",
      link: "https://metasoftdm.com/success-stories/raclettebrasseriecafe/",
      website: "https://metasoftdm.com/success-stories/raclettebrasseriecafe/",
    },

    {
      image: Zeeqr,
      category:
        "Social media management, SEO, Performance Marketing, Photography & Videography",
      title: "ZEEQR",
      link: "https://metasoftdm.com/success-stories/zeeqr/",
      website: "https://metasoftdm.com/success-stories/zeeqr/",
    },
    {
      image: AmberAroma,
      category: "Branding & Social media management",
      title: "Amber Aroma",
      link: "https://metasoftdm.com/success-stories/amberaroma/",
      website: "https://metasoftdm.com/success-stories/amberaroma/",
    },
    {
      image: AssetGlance,
      category: "Social media management, SEO & Performance Marketing",
      title: "Asset Glance",
      link: "https://metasoftdm.com/success-stories/assetglance/",
      website: "https://metasoftdm.com/success-stories/assetglance/",
    },

    {
      image: Hostec,
      category: "Branding & Social media management",
      title: "Hostec",
      link: "https://metasoftdm.com/success-stories/hostec/",
      website: "https://metasoftdm.com/success-stories/hostec/",
    },
    {
      image: ScentaBook,
      category: "Branding",
      title: "SCENTABOOK",
      link: "https://metasoftdm.com/success-stories/scentabook/",
      website: "https://metasoftdm.com/success-stories/scentabook/",
    },
    {
      image: View,
      category: "Branding & Social media management",
      title: "360 VIEW",
      link: "https://metasoftdm.com/success-stories/360view/",
      website: "https://metasoftdm.com/success-stories/360view/",
    },
    {
      image: WOW,
      category: "Branding",
      title: "Wow Luxury Limousine",
      link: "https://metasoftdm.com/success-stories/wowluxurylimousine/",
      website: "https://metasoftdm.com/success-stories/wowluxurylimousine/",
    },
    {
      image: UniWell,
      category: "Branding",
      title: "Uniwell General Trading",
      link: "https://metasoftdm.com/success-stories/uniwellgeneraltrading/",
      website: "https://metasoftdm.com/success-stories/uniwellgeneraltrading/",
    },
    {
      image: Spera,
      category: "Branding",
      title: "Spera",
      link: "https://metasoftdm.com/success-stories/spera/",
      website: "https://metasoftdm.com/success-stories/spera/",
    },
    {
      image: Karavali,
      category: "Social media management & SEO",
      title: "Karavali Interiors",
      link: "https://metasoftdm.com/success-stories/karavaliinteriors/",
      website: "https://metasoftdm.com/success-stories/karavaliinteriors/",
    },
    {
      image: SipScoop,
      category: "Branding",
      title: "Sip and Scoop",
      link: "https://metasoftdm.com/success-stories/sipscoop/",
      website: "https://metasoftdm.com/success-stories/sipscoop/",
    },
    {
      image: FatatShawarma,
      category: "Branding",
      title: "Fattet Shawarma",
      link: "https://metasoftdm.com/success-stories/fattetshawarma/",
      website: "https://metasoftdm.com/success-stories/fattetshawarma/",
    },
    {
      image: SpaceY,
      category: "Branding",
      title: "Space Y Enterprises",
      link: "https://metasoftdm.com/success-stories/fattetshawarma/", //not original
      website: "https://metasoftdm.com/success-stories/fattetshawarma/", //not original
    },

    //Genuine IT,Vibrant PU College,Al Masaood Jewellery  are pending to add
  ];

  return (
    <section>
      <div className="container">
        {/* <p className="page_info_head">Projects</p> */}
        <p className="page_info_head">Campaigns</p>
        <div className={Styles.project_info}>
          <H2>
            <span>Explore a rich collection of </span>{" "}
            <span>impactful digital strategies.</span>{" "}
            <span> Unlock Your Online Potential: </span>
            <span>Elevate Your Success with a </span>
            <span>High-Performing Marketing Campaign.</span>
          </H2>
          <p>
            Elevate Your Online Presence: Let Our Data-Driven Marketing
            Strategies Turn Your Next Campaign into a Powerful Success.
          </p>
        </div>

        <div className={styles.grid}>
          {showcaseItems.map((item, index) => (
            <div key={index} className={styles.card}>
              {item.link ? (
                <>
                  <div className={styles.imageContainer}>
                    <img
                      src={item.image}
                      alt={item.title}
                      className={styles.image}
                    />
                    <div className={styles.hoverOverlay}>
                      {/* <a
                        href={item.website}
                        target="_blank"
                        rel="noopener noreferrer"
                        className={styles.link}
                      >
                        <div className={styles.icon}>
                          <img src={wifi} alt="Live Website" />
                          <p>Live Website</p>
                        </div>
                      </a> */}

                      {/* <Link
                        to={item.link}
                        className={styles.link}
                        onClick={() =>
                          window.scrollTo({ top: 0, behavior: "smooth" })
                        }
                      >
                        <div className={styles.icon}>
                          <img src={case_studies} alt="Case Studies" />
                          <p>Case Studies</p>
                        </div>
                      </Link> */}
                      <a
                        href={item.link}
                        target="_blank"
                        rel="noopener noreferrer"
                        className={styles.link}
                      >
                        <div className={styles.icon}>
                          <img src={case_studies} alt="Case Studies" />
                          <p>Case Studies</p>
                        </div>
                      </a>
                    </div>
                  </div>
                  <p className={styles.category}>{item.category}</p>
                  {/* <h3 className={styles.title}>
                    <Link
                      to={item.link || "#"}
                      className={styles.titleLink}
                      onClick={() =>
                        window.scrollTo({ top: 0, behavior: "smooth" })
                      }
                    >
                      {item.title}
                    </Link>
                  </h3> */}
                  <h3 className={styles.title}>
                    <a
                      href={item.link}
                      target="_blank"
                      rel="noopener noreferrer"
                      className={styles.titleLink}
                    >
                      {item.title}
                    </a>
                  </h3>
                </>
              ) : (
                <>
                  <div className={styles.imageContainer}>
                    <img
                      src={item.image}
                      alt={item.title}
                      className={styles.image}
                    />
                    <div className={styles.hoverOverlay}>
                      <div className={styles.icon}>
                        <img src={wifi} alt="Live Website" />
                        <p>Live Website</p>
                      </div>
                      <div className={styles.icon}>
                        <img src={case_studies} alt="Case Studies" />
                        <p>Case Studies</p>
                      </div>
                    </div>
                  </div>
                  <p className={styles.category}>{item.category}</p>
                  <h3 className={styles.title}>{item.title}</h3>
                </>
              )}
            </div>
          ))}
        </div>

        <div className={Styles.clients}>
          <div>
            <p className={Styles.cleints_text}>Our Esteemed Clientele</p>
            <p>Join our winning team of satisfied clients</p>
          </div>

          <OurClients />
        </div>
      </div>

      <button className={Styles.scrollTop} onClick={scrollToTop}>
        Scroll Top
      </button>
    </section>
  );
}

export default DigitalMarketing;
